// Data
import actionsServiceCaller from '../lib/app/actions-service-caller';
import servicesConfig from '../../config/services-config';

const graceNoteMiddleware = (store) => (next) => (action) => {
    const {dispatch} = store;
    next(action);

    const actions = {
        SEND_TO_GRACE_NOTE_SUBMIT: () => sendObjectToGraceNote(dispatch, action),
        CONVERT_GUIDS_TO_EIDS: () => convertGuids(dispatch, action),
    };

    if (actions[action.type]) {
        return actions[action.type]();
    }
};

function convertGuids(dispatch, {guids}) {
    guids?.forEach((guid) => {
        const dispatchFetched = (response) =>
            dispatch({
                type: 'CONVERT_GUIDS_FULFILLED',
                response,
            });

        const dispatchError = (error) =>
            dispatch({
                type: 'CONVERT_GUIDS_REJECTED',
                error,
            });

        const getParams = {adult: 'false', q: `guid=="${guid}"`};
        const servicesConfigTemp = servicesConfig.graceNoteGuidToEid;
        servicesConfigTemp.getParams = getParams;

        const actionParams = {
            servicesConfig: servicesConfigTemp,
            dispatchFetched,
            dispatchError,
        };

        return Promise.resolve(actionsServiceCaller(actionParams));
    });
}

function sendObjectToGraceNote(dispatch, {object}) {
    const dispatchFetched = (response) =>
        dispatch({
            type: 'SEND_TO_GRACE_NOTE_FULFILLED',
            response,
        });

    const dispatchError = (error) =>
        dispatch({
            type: 'SEND_TO_GRACE_NOTE_REJECTED',
            error,
        });

    const actionParams = {
        servicesConfig: servicesConfig.graceNoteUpdate,
        dispatchFetched,
        dispatchError,
    };

    return Promise.resolve(actionsServiceCaller(actionParams, object));
}

export default graceNoteMiddleware;
